module.exports = __webpack_public_path__ + "img/mv.5091e702.svg";